import { SvgIcon, SvgIconProps } from '@mui/material';

const StackOverviewIcon = (props: SvgIconProps): JSX.Element => {
  return (
    <SvgIcon {...props} viewBox="0 0 40 40" fill="none">
      <rect x="4.104" y="5.2724" width="13.0912" height="13.0912" rx="3.33333" fill="currentColor" />
      <rect
        x="20.4678"
        y="11.818"
        width="10.9093"
        height="10.9093"
        rx="3.33333"
        transform="rotate(-45 20.4678 11.818)"
        fill="currentColor"
      />
      <circle cx="10.6496" cy="29.3505" r="6.5456" fill="currentColor" />
      <rect x="21.5591" y="22.8049" width="13.0912" height="13.0912" rx="3.33333" fill="currentColor" />
    </SvgIcon>
  );
};

export default StackOverviewIcon;
